import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CategoryBar from "@/components/search/CategoryBar";

export default function Layout({ children }) {
  const { pathname } = useLocation();
  // Home renders its own CategoryBar directly under the hero section.
  const showCategoryBar = pathname === "/villas";
  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Navbar />
      {showCategoryBar && <CategoryBar />}
      <Box component="main" sx={{ flex: 1 }}>{children}</Box>
      <Footer />
    </Box>
  );
}
